import React from 'react';
import { Badge, Icon, Surface, Txt } from '@vst/beam';

import { ADD_ON_STATE } from '@mfe/shared/constants';
import { GetCurrentAddOnsPayload } from '@mfe/shared/schema-types';

import { getAddonImagePropsByKind } from '../AddonIcon';

import styles from './styles.module.scss';

type MyAddonsCardProps = {
  addon: GetCurrentAddOnsPayload;
  children: React.ReactNode;
};

export const MyAddonsCard = (props: MyAddonsCardProps) => {
  const { children, addon } = props;
  const { name, kind, state } = addon;

  if (!kind) {
    return null;
  }

  const addonProps = getAddonImagePropsByKind(kind);
  const { backgroundColor, icon, beamIconColorName } = addonProps;

  const isPendingDeactivation = state.includes(ADD_ON_STATE.PENDING);
  const isIncluded = state === ADD_ON_STATE.INCLUDED;
  const badgeState = isIncluded || isPendingDeactivation ? 'infoSecondary' : 'positive';

  return (
    <div className={styles['add-on-card-container']} data-cy="addons-container">
      <Surface style={{ background: backgroundColor }} className={styles['icon-container']}>
        {icon && <Icon size="24" icon={icon} color={beamIconColorName} />}
      </Surface>
      <div className={styles['add-on-content']} data-cy="add-on-content">
        <div className={styles['title-and-badge']}>
          <Txt variant="bodyLargeBold">{name}</Txt>
          <Badge state={badgeState} label={state} showIcon={false} />
        </div>
        {children}
      </div>
    </div>
  );
};
